import React from 'react'; 
import './CompanyCard.css'
import { shopIcon, locationIcon, chefHatIcon } from '../../../../utils/icons';
import { Link } from 'react-router-dom';
import useSendProfileToCompany from '../../../../hooks/useSendProfileToCompany';
import {useAuth} from '../../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import SignedImage from '../../../Shared/SignedImage/SignedImage';



const CompanyCard = ({ company }) => {
  const { isLoading, error, successMessage, createTalentPoolRecord, isCvSent } = useSendProfileToCompany(company.id);
  const { isAuthenticated, userInfo, logout } = useAuth();
  const navigate = useNavigate()
  
  const handleSendProfile = async () => {
    if (!isAuthenticated) {
      navigate('/profesionales/entrar')
      return; 
    }

    try {
      createTalentPoolRecord();
    } catch (error) {
      console.error('Error sending profile:', error.message);
    }
  };

  const handleLocationDisplay = () => {
    const locationParts = [];
    if (company.region) locationParts.push(company.region);
    if (company.comuna && company.comuna !== "No especificado") locationParts.push(company.comuna);
    
    return locationParts.length > 0 ? locationParts.join(', ') : 'No especificado';
  };

  const handleProfileClick = () => {
    navigate(`/empresas/${company.id}`);
  };

  const handleOffersClick = () => {
    navigate(`/empresas/${company.id}`, { state: { scrollToOffers: true } });
  };

  return (
    <div className="company-card__container">
      <div className="company-card__image-container">
        <SignedImage 
          src={company.profileImageUrl}
          alt={company.name}
          className="company-conversation-card__image"
          fallbackSrc="/default-restaurant.png"
        />
      </div>
      <div className="company-card__description">
        <h3>{company.name}</h3>
        <div>
          <div className="company-card__icon-title-container">
            {shopIcon}
            <div className="company-card__info-container"> 
              <p><strong>Establecimiento:</strong></p> 
              <p>{company.format}</p>
            </div>
          </div>
          <div className="company-card__icon-title-container"> 
            {locationIcon}
            <div className="company-card__info-container">
              <p><strong>Ubicación:</strong></p> 
              <p>{handleLocationDisplay()}</p>
            </div>
          </div>
          <div className="company-card__icon-title-container">
            {chefHatIcon}
            <div className="company-card__info-container">
              <p><strong>Especialidad:</strong></p> 
              <p>{company.specialty}</p>
            </div>
          </div>
        </div>
        <div className="company-card__description-footer">
          <p>{company.description}</p>
        </div>
      </div>
      <div className="company-card__buttons">
        <button 
          onClick={handleProfileClick} 
          className="company-card__button"
        >
          Perfil
        </button>       
        <button 
          onClick={handleOffersClick} 
          className="company-card__button"
        >
          Ofertas
        </button>
        <button 
          onClick={handleSendProfile} 
          className="company-card__button"
          disabled={isCvSent} 
        >
          {isCvSent ? 'Enviado' : 'Enviar CV'}
        </button>

      </div>
    </div>
  );
};

export default CompanyCard;

